import 'dom4'
import 'svgxuse'
import SmoothScroll from 'smooth-scroll'
import domready from 'domready'
import Hurdler from 'hurdler'
import Accordion from 'accordion'
import Promise from 'promise-polyfill'
import 'babel-polyfill'
import BrowserWarning from '../browser-warning'
import Section from '../section'
import GlobalHeader from '../global-header'
import AccordionDropdown from '../accordion-dropdown'
import FormOverlay from '../form-overlay'
import ChoiceTerms from '../choice-terms'
import CalculateMyBonus from '../calculate-my-bonus'
import CalculateMyBonusCTA from '../calculate-my-bonus-cta'
import MoveMyPoints from '../move-my-points'
import VideoModule from '../video-module'

const hurdler = new Hurdler()

domready(() => {
  if (!window.Promise) {
    window.Promise = Promise
  }
  // scroll to top of window on page load
  window.onbeforeunload = () => {
    window.scrollTo(0, 0)
  }
  // Initialize browser warning
  document.queryAll('.browser-warning').forEach(element => {
    new BrowserWarning({
      element
    })
  })
  // Initialize accordion component
  document
    .queryAll('[data-component="accordion-dropdown"]')
    .forEach(element => {
      new AccordionDropdown({
        element
      })
    })
  // Initialize choice terms component
  document.queryAll('[data-component="choice-terms"]').forEach(element => {
    new ChoiceTerms({
      element
    })
  })
  // Initialize global header
  document.queryAll('[data-component="global-header"]').forEach(element => {
    new GlobalHeader({
      element,
      hurdler
    })
  })
  // Initialize video-module
  document.queryAll('[data-component="video-module"]').forEach(element => {
    new VideoModule({
      element
    })
  })
  // Initialize section component
  document.queryAll('#move-my-points').forEach(element => {
    new MoveMyPoints({
      element
    })
  })
  // Initialize get-started cta
  // document.queryAll('[data-component="get-started-cta"]').forEach(element => {
  //   new GetStartedCta({
  //     element
  //   })
  // })
  // Initialize section component
  document.queryAll('[data-component="section"]').forEach(element => {
    new Section({
      element,
      hurdler
    })
  })
  // Initialize calculate-my-bonus cta
  document.queryAll('.calculate-my-bonus-cta').forEach(element => {
    new CalculateMyBonusCTA({
      element
    })
  })
  // Initialize remind me later
  document.queryAll('[data-component="remind-me-later"]').forEach(element => {
    new RemindMeLater({
      element
    })
  })
  // Initialize form overlay
  document.queryAll('[data-component="form-overlay"]').forEach(element => {
    new FormOverlay({
      element
    })
  })
  // Initialize calculate my bonus
  document.queryAll('#calculate-my-bonus').forEach(element => {
    new CalculateMyBonus({
      element
    })
  })

  // Initialize smoothScroll
  window.smoothScroll = new SmoothScroll()
  // Initialize Hurdler
  hurdler.sprint()
})



// WEBPACK FOOTER //
// ./components/app/index.js